import type Profile from "../types/profile";

interface ProfileItemProps {
  profile: Profile;
  isWinner: boolean;
  isMod?: boolean;
  isVip?: boolean;
}

export default function ProfileItem({
  profile,
  isWinner,
}: Readonly<ProfileItemProps>) {
  return (
    <div
      className={`flex flex-col items-center mx-8 w-16 transition-all duration-500 delay-[8000ms] ${
        isWinner ? "scale-110" : ""
      }`}
    >
      <div
        className={`relative w-16 h-16 rounded-full overflow-hidden ${
          profile.isMod ? " shadow-[0px_0px_20px_5px_#06af09]" : ""
        } ${profile.isVip ? " shadow-[0px_0px_20px_5px_#e005b9]" : ""}`}
      >
        <img
          src={profile.avatar}
          alt={profile.name}
          className={`object-cover w-full `}
        />
      </div>

      <p
        className={`mt-2 text-sm font-medium text-center w-[100px] delay-[8000ms] break-words ${
          isWinner ? "text-purple-700 font-bold " : " text-white "
        } `}
      >
        {profile.name}
      </p>
    </div>
  );
}
